<div class="profile-container">
  <h2 i18n>Make my tree</h2>
  <mat-grid-list [cols]="totalCols" rowHeight="70px" (window:resize)="onResize($event)">
    <mat-grid-tile [colspan]="selectionCols" [rowspan]="selectionRows">
      <mat-card class="card selection-card">
        <mat-card-content>
          <p i18n class="mat-card-header">SELECTION</p>
          <div class="selection">
            <div class="content row">
              <div class="col-md-12">
                <mat-radio-group [(ngModel)]="type">
                  <!-- <div class="row">
                    <div class="col-md-6" style="text-align: center;">
                      <mat-radio-button i18n value="single" style="font-size: 20px;">&nbsp;Individual
                      </mat-radio-button>
                    </div>
                    <div class="col-md-6" style="text-align: center;">
                      <mat-radio-button i18n value="couple" style="font-size: 20px;">&nbsp;Family (inactive)
                      </mat-radio-button>
                    </div>
                  </div> -->

                </mat-radio-group>
              </div>
              <div class="col-md-6">
                <mat-grid-list cols="1" rowHeight="150px">
                  <mat-grid-tile>
                    <div class="item-content">
                      <p i18n class="label">Type of tree</p>
                      <mat-select [(value)]="treeType" class="select-box">
                        <mat-option i18n value="1"> Ancestral tree </mat-option>
                        <mat-option i18n value="3"> Descendancy tree (not active yet)</mat-option>
                      </mat-select>
                    </div>
                  </mat-grid-tile>
                  <mat-grid-tile>
                    <div class="item-content">
                      <p i18n class="label">Gedcom</p>
                      <mat-select [(value)]="gedcom" (selectionChange)="gedcomChanged($event)" class="select-box">
                        <mat-option i18n *ngFor="let item of gedcomfiles" [value]="item"> {{item.filename}}
                        </mat-option>
                      </mat-select>
                    </div>
                  </mat-grid-tile>
                  <mat-grid-tile>
                    <div class="item-content">
                      <p i18n class="label">Settings</p>
                      <mat-select [(value)]="setting" class="select-box">
                        <mat-option i18n value="recommended"> Recommended Settings </mat-option>
                        <mat-option i18n value="all"> All settings on </mat-option>
                      </mat-select>
                    </div>
                  </mat-grid-tile>
                </mat-grid-list>
              </div>
              <div class="col-md-6">
                <mat-grid-list cols="1" rowHeight="150px">
                  <mat-grid-tile>
                    <div class="item-content">
                      <p i18n class="label">Select paper size</p>
                      <mat-select [(value)]="papertype" class="select-box">
                        <mat-option i18n value="A0"> A0 (841 x 1188 mm MAX 10 GENERATION) </mat-option>
                        <mat-option i18n value="A1"> A1 (594 x 841 mm MAX 9 GENERATION) </mat-option>
                        <mat-option i18n value="A2"> A2 (420 x 594 mm MAX 7 GENERATION) </mat-option>
                        <!-- <mat-option i18n value="A3"> A3 (297 x 420 mm MAX 6 GENERATION)</mat-option> -->
                        <!-- <mat-option i18n value="A4"> A4 (210 x 297 mm MAX 5 GENERATION)</mat-option> -->
                      </mat-select>
                    </div>
                  </mat-grid-tile>
                  <mat-grid-tile>
                    <div class="item-content" *ngIf="type=='single'">
                      <p i18n class="label">Select start person</p>
                      <mat-select [(value)]="selectedValue" required [formControl]="selectFormControl"
                        class="select-box">
                        <input (keyup)="onKeySingle($event.target.value)" class="searchInput" placeholder="Search..."> 
                        <mat-option i18n *ngFor="let single of filtered_singles; let i = index"
                           [(value)]="single['id']">
                            {{single['firstName']}}&nbsp;{{single['lastName']}}
                        </mat-option>
                      </mat-select>
                      <!-- <mat-error *ngIf="selectFormControl.hasError('required')">
                                        This field is required
                                      </mat-error> -->
                    </div>
                    <div class="item-content" *ngIf="type=='couple'">
                      <p i18n class="label">Select start person</p>
                      <mat-select [(value)]="selectedValue" class="select-box">
                        <input (keyup)="onKeyCouple($event.target.value)" class="searchInput" placeholder="Search..."> 

                        <mat-option i18n *ngFor="let couple of filtered_couples; let i = index"
                           [(value)]="couple['id']">
                            {{couple.husb ? (nodeinfos[couple.husb].firstName ? nodeinfos[couple.husb].firstName : "") + " " + (nodeinfos[couple.husb].lastName?nodeinfos[couple.husb].lastName:"") : "?"}}&nbsp;and&nbsp;{{couple.wife ? (nodeinfos[couple.wife].firstName?nodeinfos[couple.wife].firstName:"") + " " + (nodeinfos[couple.wife].lastName?nodeinfos[couple.wife].lastName:"") : "?"}}
                        </mat-option>

                      </mat-select>
                      <!-- <mat-error *ngIf="selectFormControl.hasError('required')">
                                        This field is required
                                      </mat-error> -->
                    </div>
                  </mat-grid-tile>
                  <mat-grid-tile>
                    <div class="item-content"  *ngIf="type=='single'">
                      <p i18n class="label">Select layout</p>
                      <mat-select [(value)]="direction" class="select-box">
                        <mat-option i18n value="1"> Left to Right </mat-option>
                        <mat-option i18n value="2"> Right to Left </mat-option>
                        <mat-option i18n value="3"> Top to Bottom </mat-option>
                        <mat-option i18n value="4"> Bottom to Top </mat-option>
                        <mat-option i18n value="5"> From Center </mat-option>

                      </mat-select>
                    </div>
                    <div class="item-content"  *ngIf="type=='couple'">
                      <p i18n class="label">Select layout</p>
                      <mat-select [(value)]="direction" class="select-box">
                        <mat-option i18n value="3"> Left to Right </mat-option>
                        <mat-option i18n value="1"> Top to Bottom  </mat-option>

                      </mat-select>
                    </div>
                  </mat-grid-tile>
                </mat-grid-list>
              </div>
            </div>

            <div class="action">
              <button i18n mat-raised-button
                style="background-color: #B6C1B1; color: #470037; font-size: 20px; padding: 5px 20px;"
                (click)="generateTree()">GENERATE MY TREE</button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

    </mat-grid-tile>
    <mat-grid-tile [colspan]="helpCols" [rowspan]="helpRows">
      <mat-card class="card newsletter-card">
        <mat-card-content style="height: 100%;">
          <p i18n class="mat-card-header big">HELP</p>
          <div class="desc">
            <div class="text">
              <p i18n class="label">Get started with our help guide</p>
              <button i18n mat-raised-button
                style="background-color: #B6C1B1; color: #470037; font-size: 20px; padding: 5px 20px;"
                (click)="goToWizard()">
                Go to the help guide
              </button>
            </div>
            <div class="type">
              <div class="tree-type">
                <span i18n class="big">Individual or Family: </span>
                <div>
                  <span i18n class="oblique">Individual </span><span i18n>type of three starts from a person and his/her
                    parents, it is possible to show wife/husband and children.</span>
                  <span i18n class="oblique">Family </span><span i18n>type of tree begins with two people, as a husband
                    and wife, with their own parents, it is possible to show their children as well. </span>
                </div>
              </div>
            </div>
            <div class="text">
              <div class="tree-type"><span i18n class="big">Type of tree: </span>
                <div>
                  <span i18n class="oblique">Ancestral tree: </span><span i18n>An ancestral chart, which
                    shows all the ancestors of an individual or a couple. </span>
                  <br><span i18n class="oblique">Descendancy tree: </span><span i18n>An descendant chart, which shows
                    all the descendants of an individual or a couple</span>
                </div>
              </div>
            </div>
            <div class="text">
              <div class="tree-type">
                <span i18n class="big">Settings: </span>
                <div>
                  <span i18n>
                    There are a lot of settings that can be set by you when you design your own family tree, here you
                    can choose the starting settings for your family tree.
                  </span>
                </div>
              </div>
            </div>
            <div class="text">
              <div class="tree-type">
                <span i18n class="big">Select paper size: </span>
                <div>
                  <span i18n>We have different sizes you can choose from, depending on what size you want your tree to
                    be and how many generations you want to see.
                    <br>AO (841 x 1188 mm, max 10 generations)
                    <br>A1 (594 x 841 mm, max 9 generations)
                    <br>A2 (420 x 594 mm, max 7 generations)
                  </span>
                </div>
              </div>
            </div>
            <div class="text">
              <div class="tree-type">
                <span i18n class="big">Select start person: </span>
                <div>
                  <span i18n>For individual selection, you choose the person from whom the tree should be based on.
                    The person you choose will be the starting point for your family tree.
                    For the Family choice, you choose the pair of people that the tree should be based on, these people
                    will be the starting point for your family tree.
                  </span>
                </div>
              </div>
            </div>
            <div class="text">
              <div class="tree-type">
                <span i18n class="big">Select layout: </span>
                <div>
                  <span i18n>Choose how your family tree should be shaped. </span>
                </div>
              </div>
            </div>
          </div>

        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>